export default "__VITE_ASSET__DH74vY5f__"